var _indexOfInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/index-of");
function _isNativeFunction(fn) {
  var _context;
  return _indexOfInstanceProperty(_context = Function.toString.call(fn)).call(_context, "[native code]") !== -1;
}
module.exports = _isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;